import api from "Common/Client/Interceptor";

const getLearnersByManager = async (managerId, token) => {
  try {
    const response = await api.get(`/Learners/GetList-For-Performance-Review?managerId=${managerId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "*/*",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default {
  getLearnersByManager,
};
